import type { FC, ReactElement, ReactNode } from 'react';
import type { Option } from 'options';
import { SelectFilterChip } from './SelectFilterChip';

type SelectChipBoundProps = { name?: string; label?: string; isMulti?: boolean };

type SelectChipConfig<V extends string | number> = {
  name: string;
  label?: string;
  isMulti?: boolean;
  isSearchable?: boolean;
  defaultValueLabel?: string;
  formatOptionLabel?: (option: Option<V>) => ReactNode;
};

export function createSelectFilterChip<V extends string | number = string>(
  options: Option<V>[],
  config: SelectChipConfig<V>,
): FC<SelectChipBoundProps> {
  function BoundSelectFilterChip({
    name = config.name,
    label = config.label,
    isMulti = config.isMulti,
  }: SelectChipBoundProps): ReactElement {
    return (
      <SelectFilterChip
        name={name}
        label={label}
        isMulti={isMulti}
        options={options}
        isSearchable={config.isSearchable}
        defaultValueLabel={config.defaultValueLabel}
        formatOptionLabel={config.formatOptionLabel}
      />
    );
  }
  return BoundSelectFilterChip;
}
